import { TreeIf } from '../interfaces/tree-if';
import { DateUtil } from './date-util';
import { StringUtil } from './string-util';

export namespace TreeSort {
  export enum TreeSortType {
    PRE_ORDER,  // Y,S1,Q1,Q2,S2,Q3,Q4
    POST_ORDER, // Q1,Q2,S1,Q3,Q4,S2,Y
    LEVEL_ORDER // Y,S1,S2,Q1,Q2,Q3,Q4
  }

  export function getSortedTreesUsing(rootList: Array<TreeIf>, sortType: TreeSortType = TreeSortType.PRE_ORDER): Array<TreeIf> {
    let sortedTrees: Array<TreeIf>;
    switch (sortType) {
      case TreeSortType.LEVEL_ORDER:
        sortedTrees = traverseLevelOrder(rootList);
        break;
      case TreeSortType.POST_ORDER:
        sortedTrees = traversePostOrder(rootList);
        break;
      case TreeSortType.PRE_ORDER:
        sortedTrees = traversePreOrder(rootList);
        break;
      default:
        throw new Error('Unknown Sort Order');
    }
    return sortedTrees;
  }

  function traversePreOrder(rootList: Array<TreeIf>): Array<TreeIf> {
    let wrappers: Array<TreeIf> = [];
    return doTraversePreOrder(rootList, wrappers);
  }

  function doTraversePreOrder(rootList: Array<TreeIf>, wrappers: Array<TreeIf>): Array<TreeIf> {
    for (let parent of rootList) {
      wrappers.push(parent);
      let children: Array<TreeIf> | undefined = parent.getChildren();
      if (children != null && children.length > 0) {
        doTraversePreOrder(children, wrappers);
      }
    }

    return wrappers;
  }

  function traversePostOrder(rootList: Array<TreeIf>): Array<TreeIf> {
    let wrappers: Array<TreeIf> = [];
    return doTraversePostOrder(rootList, wrappers);
  }

  function doTraversePostOrder(rootList: Array<TreeIf>, wrappers: Array<TreeIf>): Array<TreeIf> {
    for (let parent of rootList) {
      let children = parent.getChildren();
      if (children != null && children.length > 0) {
        doTraversePostOrder(children, wrappers);
      }
      wrappers.push(parent);
    }

    return wrappers;
  }

  function traverseLevelOrder(rootList: Array<TreeIf>): Array<TreeIf> {
    let wrappers: Array<TreeIf> = [];
    return doTraverseLevelOrder(wrappers, rootList);
  }

  function doTraverseLevelOrder(wrappers: Array<TreeIf>, rootList?: Array<TreeIf>): Array<TreeIf> {
    if (rootList == null) {
      return wrappers;
    }

    for (let parent of rootList) {
      wrappers.push(parent);
    }

    for (let parent of rootList) {
      doTraverseLevelOrder(wrappers, parent.getChildren());
    }

    return wrappers;
  }

  export function sortTreesPostOrder(trees: Array<TreeIf>): Array<TreeIf> {
    return trees.sort((o1: TreeIf, o2: TreeIf): number => {
      let i: number = DateUtil.compareDates(o1.getEndDate(), o2.getEndDate());
      if (i !== 0) {
        return i;
      }

      i = DateUtil.compareDates(o2.getStartDate(), o1.getStartDate());
      if (i !== 0) {
        return i;
      }

      return StringUtil.compareStrings(o1.getReportingTermName(), o2.getReportingTermName());
    });
  }
}
